<template>
    <div>
        <div class="common-table">
        <el-table v-loading="loading" height="100%" :data="sendLog.beanList" row-key="id">
            <el-table-column type="index" label="编号" align="center"/>
            <el-table-column label="玩家昵称" align="center" prop="userName"/>
            <el-table-column label="玩家ID" align="center" prop="userRandomId"/>
            <el-table-column label="赠送金豆数量" align="center" prop="sendChips">
              <template slot-scope="scope">
                {{scope.row.sendChips/100}}
              </template>
            </el-table-column>
            <el-table-column label="赠送原因" align="center" prop="sendDesc"/>
            <el-table-column label="赠送时间" align="center" prop="opTime"/>
        </el-table>
        </div>
        <el-pagination
                class="common-el-pagination"
                layout="prev,pager,next,jumper"
                background
                :page-size="20"
                :pager-count="5"
                :total="sendLog.total"
                :current-page="currentPage"
                @current-change="getList($event)"/>
    </div>
</template>
<script>
    import {mapState,mapActions} from 'vuex'
    export default {
        data(){
            return{
                loading:false,
                currentPage:1
            }
        },
        computed:{
            ...mapState('market',['sendLog'])
        },
        methods:{
            ...mapActions('market',['getSendLogList']),
            getList(page = 1){
                this.loading = true;
                this.currentPage = page;
                this.getSendLogList(page).then(()=>{
                    this.loading = false;
                })
            }
        }
    }
</script>
